import { createApp } from 'vue/dist/vue.esm-bundler'
import apps from './apps/index'

import VIntersection from './directives/VIntersection'

// Vue app mounter: apps/index.js pairs each mount-element id with a lazy import(), so a
// page only downloads the chunks for the apps it actually renders. Shared by BOTH the
// legacy and v2 layouts — v2 pages reuse these apps by rendering the same mount-point ids
// inside v2 chrome (e.g. the photo gallery wrapped in .v2-legacy-embed). Server state
// reaches the apps two ways: data-* attrs on the mount element (below) and window.gon,
// which is why the layouts must render include_gon BEFORE the vite bundle.
//
// loadId is a race guard: mounting awaits a dynamic import, and a Turbo navigation can
// swap the <body> mid-await. Each turbo:load / turbo:before-cache bumps loadId, so a
// mount that started under a previous id abandons itself instead of mounting into a
// replaced/dead DOM node.
let loadId = 0
const mountedApps = new Map()

async function mountApp({ mount_element, loader }, currentLoadId) {
  const mountElement = document.getElementById(mount_element)

  if (!mountElement || mountedApps.has(mount_element)) return

  const { default: appClass } = await loader()
  const latestMountElement = document.getElementById(mount_element)

  if (currentLoadId !== loadId || !latestMountElement || mountedApps.has(mount_element)) return

  // Pass any data-* attributes on the mount element through as root props
  // (camelCased), so server-rendered state (e.g. the inventory app's current
  // sort + sort options) is available to the component.
  const app = createApp(appClass, { ...latestMountElement.dataset })
  app.directive('intersection', VIntersection)
  app.mount(latestMountElement)
  mountedApps.set(mount_element, app)
}

document.addEventListener('turbo:load', () => {
  loadId += 1

  apps.forEach(appConfig => {
    mountApp(appConfig, loadId)
  })
})

// this event listener is executed as soon as
// the new body was fetched successfully but
// before replacing the `document.body`
document.addEventListener('turbo:before-cache', () => {
  loadId += 1

  mountedApps.forEach(app => app.unmount())
  mountedApps.clear()
});
